import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { LandingSidenavComponent } from './landing-page/landing-components/landing-sidenav/landing-sidenav.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    NgHttpLoaderModule,
    LandingSidenavComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'workbi_admin';
}
